import { combineReducers } from 'redux';
import * as parcelsLabelsUrl from '../slices/parcelLabelsUrl';

export const reducer = combineReducers({
    [parcelsLabelsUrl.name]: parcelsLabelsUrl.reducer,
});
